import React from 'react'
import Link from 'gatsby-link'

import Liver from '../assets/liver.svg'

const IndexPage = ({ data }) => {
  const siteInfo = data.site.siteMetadata
  const content = data.allMarkdownRemark.edges[0].node

  return (
    <div className="content-container">
      <div className="section">
        <h3>Manifesto</h3>
        <ul className="manifesto">
          {siteInfo.manifesto.map((item, key) => (
            <li key={key}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="section-fw">
        <div className="card">
          <div className="card-header">
            <img src={Liver} alt="" />
            <span>{content.frontmatter.title}</span>
          </div>
          <div
            className="card-body"
            dangerouslySetInnerHTML={{ __html: content.html }}
          />
        </div>
      </div>
    </div>
  )
}

export default IndexPage

export const query = graphql`
  query HomepageQuery {
    site {
      siteMetadata {
        title
        description
        manifesto
      }
    }
    allMarkdownRemark(filter: { frontmatter: { slug: { eq: "summary" } } }) {
      edges {
        node {
          html
          frontmatter {
            title
            path
            date
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js